export enum InviteType {
  Email = "Email",
  Sms = "Sms",
}

export interface InvitationRequest {
  patientId: string;
  type: InviteType;
  email?: string;
  phoneNumber?: string;
}
